import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { ErrorResponse, httpClient } from '@/api/http-client'
import { Invitation } from '@/types/invitation'

type CreateInvitationParams = {
  deal_key: string
  name: string
  tax_id: string
  email: string
  phone: string
  profile?: 'admin' | 'collaborator' | 'partner'
}

type CreateInvitationResponse = {
  invitation: Invitation
}

export async function createInvitation({
  deal_key,
  name,
  tax_id,
  email,
  phone,
  profile = 'collaborator',
}: CreateInvitationParams) {
  const response = await httpClient(
    'accounting-dealer',
  ).post<CreateInvitationResponse>(`/v3/deal/${deal_key}/customer/deal-user`, {
    name,
    tax_id,
    email,
    phone,
    profile,
  })

  return response.data
}

export function useCreateInvitation(
  options?: UseMutationOptions<
    CreateInvitationResponse,
    ErrorResponse,
    CreateInvitationParams
  >,
) {
  return useMutation({
    mutationFn: createInvitation,
    ...options,
  })
}
